import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { AuthorizationGuardService } from './authentication/authorization-guard.service';

const ADMIN_PERM_LEVEL = 3;
const COMPTA_PERM_LEVEL = 2;
const DEFAULT_PERM_LEVEL = 0;

const routes: Routes = [

	{
		path: '',
    // redirectTo: 'dashboard/overview',
    redirectTo: 'tableaudebord',
    pathMatch: 'full'
	},
	{
		path: '',
		component: LoginLayoutComponent,
		children: [
			{
				path: 'pages',
				loadChildren: './pages/pages.module#PagesModule'
			}
		]
	},
	{
		path: '',
		component: AdminLayoutComponent,
		children: [
			{
				path: 'tableaudebord',
				loadChildren: './dashboard/dashboard.module#DashboardModule',
				canActivate: [AuthorizationGuardService],
				data: { auth_level: ADMIN_PERM_LEVEL }
			},
			{
				path: 'compte',
				loadChildren: './account/account.module#AccountModule',
				canActivate: [AuthorizationGuardService],
				data: { auth_level: ADMIN_PERM_LEVEL }
			},
			{
				path: 'mouvement',
				loadChildren: './flow/flow.module#FlowModule',
				canActivate: [AuthorizationGuardService],
				data: { auth_level: COMPTA_PERM_LEVEL }
			},
			{
				path: 'operation',
				loadChildren: './operation/operation.module#OperationModule',
				canActivate: [AuthorizationGuardService],
				data: { auth_level: ADMIN_PERM_LEVEL }
			},
			{
				path: 'commission',
				loadChildren: './commission/commission.module#CommissionModule',
				canActivate: [AuthorizationGuardService],
				data: { auth_level: ADMIN_PERM_LEVEL }
			},
			{
				path: 'configuration',
				loadChildren: './parameter/parameter.module#ParameterModule',
				canActivate: [AuthorizationGuardService],
				data: { auth_level: ADMIN_PERM_LEVEL }
			},
			{
				path: 'simulation',
				loadChildren: './simulation/simulation.module#SimulationModule',
				canActivate: [AuthorizationGuardService],
				data: { auth_level: ADMIN_PERM_LEVEL }
			}
		]
	}
];

@NgModule({
	imports: [ RouterModule.forRoot(routes) ],
	exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts